module.exports = __webpack_public_path__ + "static/img/19.69c16dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/19.jpg
// module id = imkm
// module chunks = 1